import * as React from "react";
import {
  Create,
  CreateProps,
  SimpleForm,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";

const SocialsCreate = (props: CreateProps) => {
  const [locale] = useLocaleState();

  return (
    <Create {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ImageCropInput
          slot="icon"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="picture"
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="title" label="socials.title" />
        </TranslatableInputs>
        <TextInput fullWidth source="link" label="socials.link" />
      </SimpleForm>
    </Create>
  );
};

export default SocialsCreate;
